import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export default class CollectionHelper {
  collection;
  constructor(data) {
    this.collection = new BaseCollection(data, "en");
  }

  pluck(key, find) {
    const items = Array.isArray(find.value)
      ? this.filter((i) => find.value.includes(i[find.key]))
      : this.find(find.value, find.key);
    if (!items) {
      return null;
    }

    if (Array.isArray(items)) {
      return items.map((i) => i[key]);
    }

    return [items[key]];
  }

  pluckDeep(value, key, pluck) {
    const _pd = (v, k) => {
      const page = this.find(v, k);

      if (!page) {
        return [];
      }

      const children = this.fetch({ parent: page.id });

      return children ? [page[pluck], ...children.map((child) => _pd(child[k], k, pluck))] : [page[pluck]];
    };

    return flatten(_pd(value, key));
  }

  find(value, key = "url_slug", includes = false) {
    if (includes) {
      return this.collection.getItems().find((i) => value.toLowerCase().includes(i[key].toLowerCase().trim()));
    }

    return this.collection.getItems().find((i) => i[key] === value);
  }

  filter(filter) {
    return this.fetch({ filter });
  }

  fetch({ limit = null, featured = null, parent = null, exclude = null, filter = null } = {}) {
    let items = this.collection.getItems();

    if (filter) {
      items = items.filter(filter);
    }

    if (featured) {
      items = items.filter((i) => i.featured === featured);
    }

    if (parent) {
      items = items.filter((i) => i.parent.id === parent);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    return items;
  }

  toPaths({ exclude = [], includes = [], iterator = (i) => ({ params: { url_slug: i.url_slug } }) } = {}) {
    return this.collection
      .getItems()
      .filter((i) => (includes.length > 0 ? includes.includes(i.id) : true))
      .filter((i) => !exclude.includes(i.id))
      .map(iterator);
  }

  toNestedPaths({
    exclude = [],
    includes = [],
    iterator = (i) => {
      let url_slugs = [i.url_slug];
      let page = { ...i };

      while (page?.parent?.id) {
        page = this.find(page.parent.id, "id");
        url_slugs = [page.url_slug, ...url_slugs];
      }

      return { params: { url_slugs } };
    },
  } = {}) {
    return this.toPaths({ exclude, includes, iterator });
  }
}
